export default __webpack_public_path__ + "static/media/a3m.e6b592b3.png";